import { useMutation } from 'react-query';
import { AxiosError } from 'axios';
import { Axios } from '@utils/api/axios-instance.ts';
import { POST_URL } from '@utils/api/endpoints.ts';
import type { BaseError } from '@utils/types/shared/base.ts';
import type { TestConnectionResponse } from '@utils/types/connections/connection.ts';

async function testConnection(
  connectionId: string
): Promise<TestConnectionResponse> {
  const { data } = await Axios.post<TestConnectionResponse>(
    POST_URL(connectionId).testConnection
  );
  return data;
}

export function useTestConnection() {
  return useMutation<TestConnectionResponse, AxiosError<BaseError>, string>(
    testConnection,
    { useErrorBoundary: false }
  );
}
